import { EInvoiceConsentLogEntryVM } from "./eInvoiceConsentLogEntryVM";
import HistoryPresenterItem from "./HistoryPresenterItem";

export function HistoryPresenter(props: {
  object: EInvoiceConsentLogEntryVM[];
}) {
  return (
    <>
      {props.object.length === 0 && (
        <div className="alert alert-primary" role="alert">
          <i className="bi bi-info-circle-fill text-info me-2"></i> Nie
          odnotowaliśmy żadnych zmian wprowadzonych poprzez BOK.
        </div>
      )}

      {props.object.length > 0 && (
        <div className="-app-display-section">

          {props.object.length >= 50 && (
            <div className="alert alert-primary" role="alert">
              <i className="bi bi-info-circle-fill text-info me-2"></i> Poniżej
              pokazujemy wyłącznie 50 ostatnich zmian.
            </div>
          )}

          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">Data zmiany</th>
                <th scope="col">Zmienił</th>
                <th scope="col" className="text-center">
                  Zgoda
                </th>
                <th scope="col">Email 1</th>
                <th scope="col">Email 2</th>
              </tr>
            </thead>
            <tbody>
              {props.object.map((entry) => (
                <HistoryPresenterItem key={entry.id} entry={entry} />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export default HistoryPresenter;
